import React from "react";
import { useTone } from "@/lib/imageTone";

/**
 * A product photo that fills its parent. Opaque photos are drawn exactly as before (`fit`); a photo with a transparent
 * background is shown whole on a contrasting backdrop picked from the product's colour.
 */
export default function ToneImg({ src, alt = "", fit = "cover", className = "", imgClassName = "", style, imgStyle, pad = "9%", onTone, children, ...rest }) {
  const tone = useTone(src);
  return (
    <div className={`relative w-full h-full overflow-hidden ${className}`} style={{ background: tone ? tone.bg : undefined, ...style }} data-transparent={tone ? "true" : undefined}>
      <img src={src} alt={alt} className={`w-full h-full ${tone ? "object-contain" : fit === "contain" ? "object-contain" : "object-cover"} ${imgClassName}`}
        style={{ ...(tone ? { padding: pad, filter: "drop-shadow(0 10px 14px rgba(0,0,0,.18))" } : null), ...imgStyle }} {...rest} />
      {children}
    </div>
  );
}
